<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptCheckBoxOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize"
    />
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptCheckBoxOptionBase from "@/components/element/options/comp/cpt-checkbox-option-base";
export default {
  name: "cpt-checkbox-option",
  components: { CptData, CptCheckBoxOptionBase },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  data() {
    return {
      sizeOptions: {
        small: { width: 16, height: 16, borderRadius: 0 },
        medium: { width: 20, height: 20, borderRadius: 0 },
        large: { width: 24, height: 24, borderRadius: 0 },
      },
    };
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
        this.attribute.borderRadius = sizeAttributes.borderRadius;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style>
</style>